import StructureArchive from "./StructureArchive";

export default StructureArchive;
